import { render, staticRenderFns } from "./DappsContainer.vue?vue&type=template&id=79897fac&scoped=true&"
import script from "./DappsContainer.vue?vue&type=script&lang=js&"
export * from "./DappsContainer.vue?vue&type=script&lang=js&"
import style0 from "./DappsContainer.vue?vue&type=style&index=0&id=79897fac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79897fac",
  null
  
)

export default component.exports